<template>
  <div>
    <b-row align-h="between" class="mb-3">
      <b-col cols="6">
        <b-button-group size="md">
          <b-button
            class="mr-2"
            variant="outline-success"
            @click="fromLoad('add')"
            v-if="allow('A')"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('tips_add') || '新增' }}
          </b-button>
        </b-button-group>
      </b-col>
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group>
            <b-form-input
              v-model="form.scmTagName"
              @keyup.enter="query"
              type="search"
              placeholder="Search here..."
            />
            <b-input-group-append>
              <b-button-group>
                <b-button @click="query" variant="primary" class="my-2 my-sm-0">
                  <i class="fa fa-search"></i>
                </b-button>
                <b-dropdown right variant="light" ref="dropdown">
                  <b-dd-form :inline="true" style="width: 400px;">
                    <b-form-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          :label="$l('search_label_status') || '状态'"
                        >
                          <el-select
                            v-model="form.scmTagStatus"
                            filterable
                            clearable
                            placeholder="请选择"
                            style="width:100%;"
                            size="small"
                          >
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </b-form-group>
                      </b-col>
                    </b-form-row>
                    <b-form-row>
                      <b-col style="text-align:center;">
                        <b-button block variant="primary" @click="query"
                          >Search</b-button
                        >
                        <b-button
                          block
                          variant="outline-primary"
                          @click="onReset"
                          >Reset</b-button
                        >
                      </b-col>
                    </b-form-row>
                  </b-dd-form>
                </b-dropdown>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        { value: 'Y', label: '有效' },
        { value: 'N', label: '无效' },
      ],
      form: {
        scmTagName: '',
        scmTagStatus: '',
      },
    }
  },
  methods: {
    onReset() {
      this.form = {
        scmTagName: '',
        scmTagStatus: '',
      }
      this.query()
    },
    fromLoad(val) {
      this.$emit(val)
    },
    query() {
      this.$emit('submit', this.form)
    },
    reset() {
      this.$refs.form.resetFields()
      this.query()
    },
  },
  created() {
    this.query()
  },
}
</script>
